const inPageNav = document.querySelector('.block-in-page-nav');
const labelBlock = document.querySelector('.block-in-page-nav__label');
const activeClass = 'block-in-page-nav--active';
const titleElement = document.createElement('span');
titleElement.className = 'block-in-page-nav__title';

if (!inPageNav.querySelector('.block-content')) {
	labelBlock.classList.add('block-in-page-nav__label--no-nav');
}

const navLinks = inPageNav.querySelectorAll('.is-style-navigation-link');
if (navLinks) {
	navLinks.forEach(function (navLink) {
		if (navLink.firstChild.getAttribute('href') === location.href) {
			navLink.classList.add('block-in-page-nav__selected');
		}
	});
}
if (inPageNav) {
	document
		.querySelector('.main-header')
		.classList.add('main-header--has-floater');
}

// Add the title element on page load
const selectedNavItemOnLoad = inPageNav.querySelector(
	'.block-in-page-nav__selected'
);
if (selectedNavItemOnLoad) {
	titleElement.innerHTML = selectedNavItemOnLoad.innerHTML;
	labelBlock.append(titleElement);
}

labelBlock.addEventListener('click', function () {
	if (inPageNav.classList.contains(activeClass)) {
		inPageNav.classList.remove(activeClass);
		// labelBlock.removeChild(titleElement);
	} else {
		inPageNav.classList.add(activeClass);

		const selectedNavItem = inPageNav.querySelector(
			'.block-in-page-nav__selected'
		);

		if (selectedNavItem) {
			titleElement.innerHTML = selectedNavItem.innerHTML;
			labelBlock.append(titleElement);
		}

		const buttons = inPageNav.querySelector('.block-in-page-nav__buttons');
		if (buttons) {
			buttons
				.querySelectorAll('.wp-block-button--small')
				.forEach(function (button) {
					button.classList.remove('wp-block-button--small');
				});
		}
	}
});
